export const data_user_menu = [
    {
        id: 1,
        title: 'Профиль',
        url: '/user/profile',
        group_name: 'user_setting',
        permission_key: 'user_setting'
    },{
        id: 2,
        title: 'Пароль',
        url: '/user/password',
        group_name: 'user_setting',
        permission_key: 'user_setting'
    },{
        id: 3,
        title: 'Настройки',
        url: '/user/personality',
        group_name: 'user_setting',
        permission_key: 'user_setting'
    },{
        id: 4,
        title: 'Выход',
        url: '/user/logout',
        group_name: 'user_setting',
        permission_key: 'user_setting'
    }
]